import { ServishareketduzenlePage } from './../servishareketduzenle/servishareketduzenle';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ServisHareketPage } from './../servis-hareket/servis-hareket';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the HareketDetayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-hareket-detay',
  templateUrl: 'hareket-detay.html',
})
export class HareketDetayPage {
  Liste=[];
  vWKayit: any = {};
  HareketListesi=[];
  hareketid="";

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
    public viewCtrl:ViewController,
   public navParams: NavParams) {
    if (navParams.get("vWKayit") != null) {
      this.vWKayit = navParams.get("vWKayit");
       var data = new FormData();
       data.append("Servis_id", this.vWKayit.ID);
       this.bllOrtak.islem(data, "HareketDetayGetirByID", "", false).then(a => {
         var Sonuc = <any>a;
        this.HareketListesi= Sonuc.SonucObject;
                   
       })
      }
      
  }

  ionViewDidLoad() {
    
    this.hareketgetir();
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  hareketgetir()
  {
    var formData = new FormData();
  this.hareketid=this.vWKayit.ID;
 
    formData.append("Servis_id", this.hareketid);

    this.bllOrtak.islem(formData, "ServisHareketGetirByID","", false).then(a => {
     
      var sonuc = <any>a;
      this.HareketListesi = sonuc.SonucObject;
     
   
 
    })
    
  }
  kayitduzenle(hareket)
  {
    let modal = this.modalCtrl.create(ServishareketduzenlePage, { vWKayit: hareket});
  
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }
  kayitsil(hareket)
  {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", hareket.ID);

      this.bllOrtak.islem(formData, "ServisHareketSil", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
         this.hareketgetir();

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
    
     
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/hareket-detay/hareket-detay.ts